import { Injectable, Injector } from '@angular/core';
import { AuthenticationService } from '../../app/_services/authentication.service';
import { SettingsService } from './settings.service';

@Injectable({
    providedIn: 'root'
})
export class SessionService {

    private timeout: any;

    constructor(
        private injector: Injector,
        private settingService: SettingsService
    ) {
    }

    /**
     * Checks the session time of frontend application
     */
    public initSessionCheck() {
        const self = this;

        self.stopSessionCheck();

        self.timeout = setTimeout(() => {
            self.checkSession();
        }, 1000 * 60 * this.settingService.sessionTime);
    }

    public checkSession(): void {
        const self = this;
        const authenticationService: AuthenticationService = self.injector.get(AuthenticationService);

        authenticationService.logoutBySessionExpired();
    }

    public stopSessionCheck(): void {
        const self = this;

        if (self.timeout) {
            clearTimeout(self.timeout);
        }
    }
}
